import withIcon from './NewIcon';
// @ts-ignore
import IconBirdLogo from './icon/nav/bird.s.svg';

export default withIcon(IconBirdLogo);
